import * as ACTIONS from './mutation-types';
import { State } from './state';
import { BackgroundCheckProvider, BackgroundReportSearch, NotificationLog } from '@/interfaces';
import { BackgroundCheckReport } from '@/interfaces/BackgroundCheckReport';
import { BuilderVersion } from '@/interfaces/BuildVersion';
import { VolunteerVerification } from '@/interfaces/VolunteerVerification';
import { GumshoeUser } from '@/models';

const mutations = {
  [ACTIONS.EXECUTING](state: State) {
    state.isBusy = true;
  },
  [ACTIONS.COMPLETE](state) {
    state.isBusy = false;
  },
  [ACTIONS.ERROR](state, e) {
    state.isBusy = false;
    if (e && e.status === 401) {
      this._vm.$eventHub.$emit('authError', `An Exception Occurred. ${e}`);
    }
  },

  [ACTIONS.SET_CURRENT_USER](state: State, user: GumshoeUser) {

    state.currentUser = user;
    if (user && user.isAuthenticated) {
      localStorage.setItem('currentUser', JSON.stringify(user));
    } else {
      localStorage.clear();
    }
  },

  [ACTIONS.LOGOUT](state) {
    state.isLoggedIn = false;
  },
  [ACTIONS.SET_DIALOG_STATE](state: State, isOpen: boolean) {
    state.dialogOpen = isOpen;
  },

  [ACTIONS.SET_PROVIDERS](state: State, providers: BackgroundCheckProvider[]) {
    console.log('setting state', providers);
    state.providers = providers;
  },
  [ACTIONS.SET_REPORTS](state: State, reports: BackgroundReportSearch[]) {
    state.reports = reports;
  },
  [ACTIONS.SET_REPORT_DETAILS](state: State, report: BackgroundCheckReport) {
    state.reportDetails = report;
  },
  [ACTIONS.SET_BUILD_VERSION](state: State, report: BuilderVersion) {
    state.buildVersion = report;
  },
  [ACTIONS.SET_VERIFICATION](state: State, model: VolunteerVerification) {
    state.volunteerVerification = model;
  },
  [ACTIONS.SET_VERIFICATIONS](state: State, model: VolunteerVerification[]) {
    state.verifications = model;
  },
  [ACTIONS.SET_POSTBACK_ERROR_LOG](state: State, model: NotificationLog) {
    state.postbackErrorLog = model;
  },
  [ACTIONS.SET_POSTBACK_ERROR_LOGS](state: State, model: NotificationLog[]) {
    state.postbackErrorLogs = model;
  },
  [ACTIONS.SET_USERS](state: State, model: GumshoeUser[]) {
    state.users = model;
  },
  [ACTIONS.SET_USER](state: State, model: GumshoeUser) {
    state.selectedUser = model;
  }
};

export default mutations;
